export const allSitesOption = { name: "All" };